import React from 'react';
import { Tooltip } from 'react-bootstrap';



export default function getTooltip(text) {
  return (
    <Tooltip id={text}><strong>{text}</strong></Tooltip>
  );
}



// WEBPACK FOOTER //
// ./src/businessLogic/getTooltip.js